import DeleteButton from "../../../SharedComponent/ActionButtons/DeleteButton";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import { openDeleteTemplateConfirmationModal, openDeleteUserConfirmationModal } from "../../../../redux/SettingModule/OrganizationDetailPage/OrganizationDetailAction";
import { setCurrentRecord } from "../../../../redux/SettingModule/UsersPage/UsersAction";

function ActionColumnButtons(props: any) {
  const dispatch = useAppDispatch();
  return (
    <div className="d-flex gap-2 w-100 justify-content-center">
      {props.type === "user" && (
        <DeleteButton
          onClick={() => {
            if (props.type === "user") {
              dispatch(setCurrentRecord(props.record));
              dispatch(openDeleteUserConfirmationModal());
            } else {
              dispatch(openDeleteTemplateConfirmationModal());
            }
          }}
        />
      )}
    </div>
  );
}

export default ActionColumnButtons;
